import React from "react";
import "react-phone-input-2/lib/material.css";
import { parsePhoneNumberFromString } from "libphonenumber-js";

/**
 * Dado um numero de telefone (ex: "5511999999999" ou "+5511999999999"),
 * retorna o codigo ISO do pais (ex: "br") usando libphonenumber-js.
 * Analisa DDI + comprimento + prefixos regionais para resultado preciso.
 */
export function getCountryFromNumber(number) {
	if (!number) return "br";

	let input = String(number).trim();
	// Garante que comeca com + para a lib parsear corretamente
	if (!input.startsWith("+")) {
		input = "+" + input;
	}

	try {
		const parsed = parsePhoneNumberFromString(input);
		if (parsed && parsed.country) {
			return parsed.country.toLowerCase();
		}
	} catch (e) {
		// fallback silencioso
	}

	return "br";
}

/**
 * Componente que renderiza a bandeira do pais usando o sprite CSS
 * do react-phone-input-2.
 */
export function CountryFlag({ number, countryCode, size = 20, style = {} }) {
	const iso = countryCode || getCountryFromNumber(number);

	return (
		<span
			className="react-tel-input"
			style={{
				display: "inline-flex",
				alignItems: "center",
				justifyContent: "center",
				width: 25,
				height: 15,
				position: "relative",
				flexShrink: 0,
				...style,
			}}
		>
			<div
				className={`flag ${iso}`}
				style={{
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: `translate(-50%, -50%) scale(${size / 20})`,
				}}
			/>
		</span>
	);
}
